// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"4590624b","788":"c1a05d1d","993":"26b5db62"}[chunkId] + ".chunk.js";
};